<template>
  <div class="question_box">
    <div class="question_div">
      <img
        class="head_sculpture"
        :src="
          questionData.createHeadUrl ||
          require('../../../assets/images/argicSubjectInfo/header_photo.png')
        "
        alt=""
      />
      <div class="question_user">
        <div class="user_name">
          <h5>{{ questionData.createName }}</h5>
          <el-button
            icon="el-icon-delete"
            type="text"
            v-if="permissionResultList[1]"
            @click="removeQuestion(questionData.id)"
          >
            删除问题
          </el-button>
        </div>
        <div class="user_time">
          {{ questionData.createTime }}
          <em>{{ questionData.cityName }}{{ questionData.countyName }}</em>
        </div>
        <div class="user_text">{{ questionData.queryRemark }}</div>
        <div class="user_img" v-if="questionData.queryImage">
          <el-image
            v-for="(item, index) in questionData.queryImage.split(',')"
            :key="index"
            style="width: 100px; height: 100px"
            :src="item"
            :preview-src-list="questionData.queryImage.split(',')"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="answer_head">
      <p>回复</p>
      <el-button
        icon="el-icon-document"
        type="primary"
        plain
        v-if="permissionResultList[2]"
        @click="probeFun(questionData.id)"
      >
        追问
      </el-button>
    </div>
    <div v-if="questionData.answers">
      <answer
        v-for="(item, index) in answerList"
        :key="index"
        :answerData="item"
        :deleteState="permissionResultList[3]"
      ></answer>
    </div>
    <el-empty
      v-if="!questionData.answers"
      :image-size="80"
      description="暂无回复"
    ></el-empty>
    <div
      class="answer_length"
      v-if="questionData.answers && questionData.answers.length > 3 && isShow"
    >
      共 {{ questionData.answers.length }} 条回复，
      <span @click="isShow = false">
        点击展开<i class="el-icon-caret-bottom"></i>
      </span>
    </div>
  </div>
</template>
<script>
import answer from "./answer.vue";
import { expertConsultation } from "@/api/request/snkd.produce";
export default {
  components: {
    answer,
  },
  props: {
    questionData: {
      type: Object,
      require: true,
    },
    permissionResultList: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      isShow: true,
    };
  },
  computed: {
    answerList() {
      let list = [];
      if (!this.questionData.answers) {
        list = [];
      }
      if (this.questionData.answers.length > 3 && this.isShow) {
        list = this.questionData.answers.slice(0, 3);
      }
      if (this.questionData.answers.length <= 3 || !this.isShow) {
        list = this.questionData.answers;
      }
      return list;
    },
  },
  methods: {
    removeQuestion(id) {
      this.$confirm("是否确定删除该问题及对应回复内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await expertConsultation.updateToRemove(id);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.$emit("getList");
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    probeFun(id) {
      this.$emit("backData", id);
    },
  },
};
</script>
<style scoped lang="scss">
.question_div {
  display: flex;
  align-items: flex-start;
  .head_sculpture {
    width: 50px;
    border-radius: 50%;
  }
  .question_user {
    width: 100%;
    padding: 0 0 10px 20px;
    box-sizing: border-box;
    .user_name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 3px;
      h5 {
        font-size: 20px;
        color: #333;
      }
      ::v-deep .el-button--text {
        color: #999;
      }
    }
    .user_time {
      color: #999;
      font-size: 16px;
      margin: 10px 0;
      em {
        margin-left: 30px;
      }
    }
    .user_text {
      color: #666;
      font-size: 16px;
      line-height: 26px;
    }
    .user_img {
      margin-top: 10px;
      .el-image {
        width: 100px;
        margin-right: 20px;
        border-radius: 4px;
      }
      :last-child {
        margin-right: 0px;
      }
    }
  }
}

.answer_length {
  text-align: center;
  color: #666;
  font-size: 16px;
  padding-bottom: 30px;
  span {
    color: #64c3a4;
    cursor: pointer;
  }
}

.question_box {
  border-bottom: 1px solid #dde2e7;
  margin-bottom: 20px;
}

.answer_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  p {
    color: #64c3a4;
    font-size: 18px;
    font-weight: 700;
  }
  ::v-deep .el-button {
    border-radius: 30px;
    padding: 5px 11px;
  }
}

::v-deep .el-empty {
  padding-top: 0px;
}
</style>
